export const Bhavnagar = {
    title: "Bhavnagar",
    title1: "(Coastal)",
    attractions: [
        {
            name: "Blackbuck National Park",
            description: "Located near Velavadar, this national park is renowned for its population of blackbucks, wolves, and various bird species. It is one of the largest grasslands in India and offers a unique wildlife experience. The park is also a haven for birdwatchers, especially during the migratory season.",
            location: "Velavadar, Bhavnagar District",
            timings: "6:00 AM to 5:00 PM",
            ticket: "INR 200 for Indians, INR 1000 for foreigners",
            bestTimeToVisit: "October to March",
            activities: [
                "Wildlife safari to spot blackbucks and wolves",
                "Birdwatching, especially for migratory birds",
                "Photography in the vast grasslands",
                "Visit the interpretation center",
                "Enjoy the serene natural surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Takhteshwar Temple",
            description: "Perched on a hill, this ancient Shiva temple offers panoramic views of Bhavnagar and the Gulf of Khambhat. Built in 1893, the temple is a fine example of Indian architecture and is a peaceful place for spiritual seekers.",
            location: "Takhteshwar Hill, Bhavnagar",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Seek blessings at the Shiva temple",
                "Enjoy the breathtaking view of the city and sea",
                "Photography of the temple and surroundings",
                "Meditate in the serene environment",
                "Explore the nearby areas"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Bhartiya Sanskriti Darshan Museum",
            description: "This museum showcases the rich cultural heritage of India, with exhibits ranging from ancient artifacts to modern art. It is a treasure trove for history and art enthusiasts, offering insights into India's diverse traditions.",
            location: "Gandhi Smriti, Bhavnagar",
            timings: "10:00 AM to 6:00 PM",
            ticket: "INR 20 for Indians, INR 100 for foreigners",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore ancient artifacts and sculptures",
                "Learn about Indian culture and traditions",
                "Attend cultural events and exhibitions",
                "Photography of the exhibits",
                "Visit the library for historical books"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Gaurishankar Lake",
            description: "A serene and picturesque lake located in the heart of Bhavnagar, perfect for a peaceful stroll or a boat ride. The lake is surrounded by lush greenery and is a popular spot for locals and tourists alike.",
            location: "Bhavnagar City Center",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Boating in the lake",
                "Enjoy the scenic beauty",
                "Photography of the lake and surroundings",
                "Relax in the peaceful environment",
                "Visit the nearby gardens"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Nilambag Palace",
            description: "A stunning heritage hotel that was once the residence of the royal family of Bhavnagar. The palace is known for its exquisite architecture, lush gardens, and luxurious ambiance.",
            location: "Near Ghogha Circle, Bhavnagar",
            timings: "10:00 AM to 6:00 PM",
            ticket: "INR 100 for Indians, INR 200 for foreigners",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Explore the royal architecture",
                "Stroll through the beautiful gardens",
                "Photography of the palace",
                "Enjoy a heritage stay",
                "Dine at the royal restaurant"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Victoria Park",
            description: "A well-maintained park with lush greenery, walking trails, and a variety of flora and fauna. It is a great place for nature lovers and those seeking a peaceful retreat.",
            location: "Bhavnagar City Center",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Enjoy a peaceful walk",
                "Photography of the park",
                "Birdwatching",
                "Relax in the natural surroundings",
                "Visit the nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Ghogha Beach",
            description: "A tranquil beach located near Bhavnagar, known for its serene environment and beautiful sunsets. It is a perfect spot for relaxation and enjoying the natural beauty of the coastline.",
            location: "Ghogha, Bhavnagar District",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Enjoy the sunset",
                "Take a peaceful walk along the beach",
                "Photography of the coastline",
                "Relax in the serene environment",
                "Visit the nearby temples"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Bortalav Lake",
            description: "A beautiful lake surrounded by lush greenery, offering a peaceful retreat for visitors. It is a popular spot for picnics and leisurely walks.",
            location: "Bhavnagar City Center",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Enjoy a picnic by the lake",
                "Photography of the lake and surroundings",
                "Relax in the peaceful environment",
                "Take a leisurely walk",
                "Visit the nearby gardens"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Gandhi Smriti",
            description: "A memorial dedicated to Mahatma Gandhi, showcasing his life and teachings through exhibits and artifacts. It is a place of historical significance and a must-visit for those interested in India's freedom struggle.",
            location: "Bhavnagar City Center",
            timings: "10:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Learn about Gandhi's life and teachings",
                "Explore the exhibits and artifacts",
                "Photography of the memorial",
                "Attend cultural events",
                "Visit the library"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Alang Ship Breaking Yard",
            description: "One of the largest ship-breaking yards in the world, located near Bhavnagar. It offers a unique insight into the ship-breaking industry and its impact on the local economy.",
            location: "Alang, Bhavnagar District",
            timings: "9:00 AM to 5:00 PM",
            ticket: "Permission required for entry",
            bestTimeToVisit: "Morning",
            activities: [
                "Witness the ship-breaking process",
                "Learn about the industry",
                "Photography (with permission)",
                "Visit the nearby areas",
                "Understand the environmental impact"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Palitana Temples",
            description: "Located near Bhavnagar, Palitana is a major pilgrimage site for Jains, with over 900 temples atop Shatrunjaya Hill. It is one of the most sacred places for Jainism and offers breathtaking views.",
            location: "Palitana, Bhavnagar District",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Climb the hill to visit the temples",
                "Seek blessings at the Jain temples",
                "Enjoy the panoramic views",
                "Photography of the temples and surroundings",
                "Learn about Jainism"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Piram Island",
            description: "A small island located in the Gulf of Khambhat, known for its ancient ruins and serene environment. It is a great place for history enthusiasts and nature lovers.",
            location: "Gulf of Khambhat, Bhavnagar District",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Explore the ancient ruins",
                "Enjoy the serene environment",
                "Photography of the island",
                "Relax by the sea",
                "Visit the nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Bhavnagar Lock Gate",
            description: "A unique engineering marvel, the lock gate connects the Gulf of Khambhat with the Bhavnagar Creek. It is a fascinating place to visit for those interested in maritime history and engineering.",
            location: "Bhavnagar Creek, Bhavnagar",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Learn about the lock gate's functioning",
                "Photography of the gate and surroundings",
                "Enjoy the view of the creek",
                "Visit the nearby areas",
                "Understand the maritime history"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Khodiyar Mata Temple",
            description: "A popular temple dedicated to Goddess Khodiyar, located near Bhavnagar. It is a significant pilgrimage site and attracts devotees from all over Gujarat.",
            location: "Khodiyar, Bhavnagar District",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Seek blessings at the temple",
                "Attend the aarti and rituals",
                "Photography of the temple",
                "Explore the nearby areas",
                "Enjoy the spiritual environment"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
        {
            name: "Sihor",
            description: "A historic town near Bhavnagar, known for its ancient temples and cultural heritage. It is a great place for history buffs and those interested in exploring traditional Gujarat.",
            location: "Sihor, Bhavnagar District",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Visit the ancient temples",
                "Explore the town's cultural heritage",
                "Photography of the historic sites",
                "Learn about the town's history",
                "Enjoy the traditional ambiance"
            ],
            mapLink: "https://maps.app.goo.gl/8z5Z5Z5Z5Z5Z5Z5Z",
        },
    ]
};